import { createContext, useContext } from 'react';

export const FullscreenContentContext = createContext(false);

export const useFullscreenContent = () => useContext(FullscreenContentContext);
